import React, { Component } from 'react';

export default class Footer extends Component{
//constructor

//functions

  render() {
    return(
      <div className="footer">Copyright <a target="_blank" rel=" noopener noreferrer" href="http://nikkster.tech">nikkster.tech</a></div>
    )
  }
}
